import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TableColumn } from 'app/components/mat-custom-table/tableColumn';
import { EstadoPagare } from 'app/models/pagare.model';
import moment from 'moment';
import { take } from 'rxjs';
import { ReportePagareService } from 'app/services/reportes-pagares';
import { EstadoHtml } from 'app/shared/estado-html';
import { ExcelApi } from 'app/models/excel.model';
import { ExcelService } from 'app/services/excel.service';
import { saveAs } from 'file-saver';

interface Food {
    value: string;
    viewValue: string;
}


@Component({
    selector: 'reporte-pagares',
    templateUrl: './reporte-pagares.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class ReportePagaresComponent implements OnInit {
    constructor(private route: Router, private _reportePagareService: ReportePagareService, private _excelService: ExcelService) { }
    search: string = '';
    currentSearch: string = '';
    public customPatterns = { '0': { pattern: new RegExp('^[a-zA-ZñÑáéíóúÁÉÍÓÚ .-@_\-]{1,30}$') } };
    selected = '1';

    estadosPagare: EstadoPagare[] = [];
    estadoSelected: number = 0;

    start: moment.Moment = moment().add(-30, 'd');
    end: moment.Moment = moment();
    loadingExcel: boolean = false;


    ngOnInit() {
        this.listar();
        this.listarEstados();
    }

    buscar() {
        this.currentSearch = this.search;
        this.listar();
    }

    listarEstados() {
        this._reportePagareService.listarEstadosPagare().subscribe(estadosP => {
            this.estadosPagare = estadosP as EstadoPagare[]
            if (this.estadosPagare.length > 0) {
                this.estadoSelected = 0;

                this.estadosPagare.unshift({
                    ID_ESTADO: 0,
                    NOMBRE_ESTADO: 'TODOS',
                });
            }
        });
    }

    listar() {
        if (this.start && this.end) {
            let start = this.start.format('yyyy-MM-DD');
            let end = this.end.format('yyyy-MM-DD');
            this._reportePagareService
                .getPagares(this.currentSearch, this.estadoSelected, start, end)
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        this.dataSource = data.DETAIL;
                    },
                    error: (err: any) => {
                        console.log(err);
                        this.dataSource = [];
                    },
                    complete: () => { },
                });
        }
    }


    dateRangeChange($event: any, dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        this.listar();
    }




    foods: Food[] = [
        { value: '1', viewValue: 'Seleccione' },
        { value: '2', viewValue: 'En proceso' },
        { value: '3', viewValue: 'Pagado' },
    ];
    date = new FormControl(new Date());

    goback(): void {
        this.route.navigateByUrl('home/reportes');
    }

    columns: TableColumn[] = [
        { columnDef: 'RUTDV', header: 'rut', headerClass: "px-1.5 uppercase w-20", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'CUENTA_FINANCIERA', header: 'cuenta', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'IMEI', header: 'IMEI', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'PCS', header: 'PCS', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'RAZON_SOCIAL', header: 'RAZÓN SOCIAL', headerClass: "px-1.5 uppercase w-36", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'MONTO_TOTAL', header: 'MONTO TOTAL', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "currency", columnFormat: "CLP", columnSort: true },
        { columnDef: 'FECHA_VENCIMIENTO', header: 'FECHA VENC PAGARÉ', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "date", columnFormat: "dd/MM/YYYY", columnSort: true },
        { columnDef: 'NRO_CONTRATO', header: 'Nº contrato', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'FECHA_CONTRATO', header: 'FECHA FIRMA CONTRATO', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "date", columnFormat: "dd/MM/YYYY", columnSort: true },
        { columnDef: 'FECHA_VERIFICACION_PAGO', header: 'FECHA VERIF PAGO', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "date", columnFormat: "dd/MM/YYYY", columnSort: true },
        { columnDef: 'IMPUESTO', header: 'impuesto operación', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "number", columnFormat: "", columnSort: true },
        { columnDef: 'NOMBRE_ESTADO', header: 'estado', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'flex items-center gap-2', columnType: "custom", columnFormat: "", columnSort: true, columFunction: this.printEstado },
        { columnDef: 'NRO_ROL', header: 'n° rol', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'MONTO_RECAUDADO', header: 'monto recaudado', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "currency", columnFormat: "CLP", columnSort: true },
        { columnDef: 'MOTIVO_ANULACION', header: 'motivo anulación', headerClass: "px-1.5 uppercase w-36", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'FECHA_ACELERADOS', header: 'Fecha Factura CA Acelerados', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "date", columnFormat: "dd/MM/YYYY", columnSort: true },
        { columnDef: 'MONTO_CUOTA', header: 'Monto Factura CA con Cuota Mensual', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "currency", columnFormat: "CLP", columnSort: true },
        { columnDef: 'MONTO_OTROS_SERVICIOS', header: 'Monto Factura CA Otros Servicios', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "currency", columnFormat: "CLP", columnSort: true },
        { columnDef: 'MONTO_ACELERADO', header: 'Monto Factura CA Acelerado', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "currency", columnFormat: "CLP", columnSort: true },
        { columnDef: 'COMUNA', header: 'Comuna Dirección legal', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'FOLIO_ACELERADA', header: 'Folio Factura Acelerada', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'DIRECCION', header: 'Dirección legal', headerClass: "px-1.5 uppercase w-40", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'CORREO_ELECTRONICO', header: 'Correo Electrónico', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },
        { columnDef: 'FOLIO_CUOTA', header: 'Folio Factura CA con Cuota Mensual', headerClass: "px-1.5 uppercase", columnClass: "px-1.5 paragraph-5 text-center", columnClassMobile: 'paragraph-4', columnType: "string", columnFormat: "", columnSort: true },


    ]





    dataSource: any[] = [];

    selection = new SelectionModel<any>(true, []);
    printEstado(row: any, attribute: string): string {
        let estadoHtml = new EstadoHtml();
        return estadoHtml.generate(row.ID_ESTADO);
    }

    descargarExcel() {
        let excel: ExcelApi = {
            config: {
                workSheetName: 'LibroPagare',
                columns: [
                    { dataKey: 'RUTDV', tittle: 'rut', type: 'string', width: 20 },
                    { dataKey: 'CUENTA_FINANCIERA', tittle: 'cuenta', type: "number", width: 30 },
                    { dataKey: 'IMEI', tittle: 'IMEI', type: "string", width: 20 },
                    { dataKey: 'PCS', tittle: 'PCS', type: "string", width: 20 },
                    { dataKey: 'RAZON_SOCIAL', tittle: 'RAZÓN SOCIAL', type: "string", width: 20 },
                    { dataKey: 'MONTO_TOTAL', tittle: 'MONTO TOTAL', type: "number", width: 20 },
                    { dataKey: 'FECHA_VENCIMIENTO', tittle: 'FECHA VENC PAGARÉ', type: "date", width: 20 },
                    { dataKey: 'NRO_CONTRATO', tittle: 'Nº contrato', type: "string", width: 20 },
                    { dataKey: 'FECHA_CONTRATO', tittle: 'FECHA FIRMA CONTRATO', type: "date", width: 20 },
                    { dataKey: 'FECHA_VERIFICACION_PAGO', tittle: 'FECHA VERIF PAGO', type: "date", width: 20 },
                    { dataKey: 'IMPUESTO', tittle: 'impuesto operación', type: "number", width: 20 },
                    { dataKey: 'NOMBRE_ESTADO', tittle: 'Estado', type: "string", width: 20 },
                    { dataKey: 'NRO_ROL', tittle: 'n° rol', type: "string", width: 20 },
                    { dataKey: 'MONTO_RECAUDADO', tittle: 'monto recaudado', type: "string", width: 20 },
                    { dataKey: 'MOTIVO_ANULACION', tittle: 'motivo anulación', type: "string", width: 20 },
                    { dataKey: 'FECHA_ACELERADOS', tittle: 'Fecha Factura CA Acelerados', type: "date", width: 20 },
                    { dataKey: 'MONTO_CUOTA', tittle: 'Monto Factura CA con Cuota Mensual', type: "number", width: 20 },
                    { dataKey: 'MONTO_OTROS_SERVICIOS', tittle: 'Monto Factura CA Otros Servicios', type: "number", width: 20 },
                    { dataKey: 'MONTO_ACELERADO', tittle: 'Monto Factura CA Acelerado', type: "number", width: 20 },
                    { dataKey: 'COMUNA', tittle: 'Comuna Dirección legal', type: "string", width: 20 },
                    { dataKey: 'FOLIO_ACELERADA', tittle: 'Folio Factura Acelerada', type: "string", width: 20 },
                    { dataKey: 'DIRECCION', tittle: 'Dirección legal', type: "string", width: 20 },
                    { dataKey: 'CORREO_ELECTRONICO', tittle: 'Correo Electrónico', type: "string", width: 20 },
                    { dataKey: 'FOLIO_CUOTA', tittle: 'Folio Factura CA con Cuota Mensual', type: "string", width: 20 },
                ],
            },
            arrData: this.dataSource,
        };

        if (excel.arrData.length > 0) {
            this.loadingExcel = true;
            this._excelService.generarExcel(excel).subscribe({
                next: (resp) => {
                    saveAs(resp.body, 'ReportePagare');
                    this.loadingExcel = false;
                },
                error: (err) => {
                    //console.log('Err Excel');
                    //console.log(err);
                    this.loadingExcel = false;
                },
                complete: () => { },
            });
        }
    }


}
